import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'bl-pesquisar-input',
    templateUrl: './pesquisar-input.component.html',
    styleUrls: ['./pesquisar-input.component.scss'],
    standalone: false
})
export class PesquisarInputComponent {
  @Input() disabled = false;

  @Output() onSearch = new EventEmitter<string>();

  onSearchChange(value: string) {
    this.onSearch.emit(value);
  }
}
